function roundNumber(num) {
    return Math.round(num)
}

function formatterNumber(value) {
    if (value && value.length === 0) return null
    return value.replace(/[^0-9.]/g, '');
}

function formatterPrice(value, maxValue = null) {
    if (maxValue && parserPrice(value) >= maxValue) value = maxValue + ''
    return (value + '').replace(/[^0-9.]/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

function parserPrice(value, maxValue = null) {
    if (maxValue && parserPrice(value) >= maxValue) value = maxValue + ''
    return (value + '').replace(/[^0-9.]/g, '').replace(/\$\s?|(,*)/g, '');
}

const dataUpdate = (val, object = [], data) => {
    let reserve = [];
    object.forEach((item) => {
        reserve.push(item);
        if (item.value === val) {
            item["children"] = data.map((child) => {
                return {
                    label: child.title,
                    value: child.id
                };
            });
        } else {
            dataUpdate(val, item.children, data);
        }
    });
    return reserve;
};


export {roundNumber, formatterPrice, parserPrice, formatterNumber, dataUpdate}
